// <script src="//shopfy-features.myshopify.com/cdn/shop/t/2/assets/b__american-amuse-co.js" defer></script>
console.log('feature')